import React from 'react';

export default function DropboxIconNew(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="31" viewBox="0 0 36 31" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.09261 0.666668L0.185303 6.12097L9.09261 11.5751L0.185303 17.0294L9.09261 22.4836L18.0001 17.0294L26.9074 22.4836L35.8147 17.0294L26.9074 11.5751L35.8147 6.19612L26.9074 0.666668L18.0001 6.12097L9.09261 0.666668ZM18.0001 6.12097L26.9074 11.5751L18.0001 17.0294L9.09261 11.5751L18.0001 6.12097Z"
        fill="#0061FE"
      />
      <path d="M9.09253 25.2125L18 19.7583L22.4536 22.4855L26.9073 25.2125L18 30.6668L9.09253 25.2125Z" fill="#0061FE" />
    </svg>
  );
}
